import React, {Component} from 'react';
import $ from 'jquery';
import Navigation from '../components/navigation_component.js';
import SearchResults from '../containers/card_container.js';
import QueryBox from '../containers/query_box.js';
import MapContainer from '../containers/map_container.js';
import MapStyle from '../styles/map_styling.js';
import SectionTitle from '../components/section_title.js';
import Journey from '../containers/journey_container.js';
//css grid and styled-components imported:
import {Container, NavigationBar, Content} from '../styles/app_styles.js';
import {Results, CardStyle, MapPlacement} from '../styles/app_styles.js';
import {LowerTitle, ProtoFlag} from '../styles/app_styles.js';
import {Title, SearchSection, ImgDisclaimer} from '../styles/app_styles';
import { DescLi } from '../styles/journey_styles';
import AppWrapper from "../containers/wrapper";
import './../index.css'
import image_dict from '../img_data.js';
import exclusive_image_dict from '../exclusive_image_pairs';

const url = process.env.REACT_APP_ENDPOINT

export default class App extends Component {
  constructor(props) {
    super(props);
    const defaultNav = "hotels"
    var seed = Math.floor(Math.random() * 12)
    this.state = {
      query_terms: [],
      results: [],
      query_hovered: "",
      nav_selection: defaultNav,
      hotel_favs: [],
      attraction_favs: [],
      restaurant_favs: [],
      hover_active: null,
      trigger_fadein: true,
      rand_array: [],
      seed: seed,
      image_entity_dict: {}
    }
    this.querySearch = this.querySearch.bind(this);
    this.eventLogToServer = this.eventLogToServer.bind(this);
    this.deleteQuery = this.deleteQuery.bind(this);
    this.renderRevSummary = this.renderRevSummary.bind(this);
    this.updateHoverState = this.updateHoverState.bind(this);
    this.disableHover = this.disableHover.bind(this)
    this.navSelection = this.navSelection.bind(this);
    this.updateFavorites = this.updateFavorites.bind(this);
    this.displayBody = this.displayBody.bind(this);
    this.defaultSearch(defaultNav);
    this.seeWholeJourney = this.seeWholeJourney.bind(this);
  }

  defaultSearch(navSelection){
    var walletData = [];
    switch(navSelection){
      case "hotels":
      walletData = ["sparkling clean", "quiet"]
      break;
      case "attractions":
      walletData = ["affordable"]
      break;
      case "restaurants":
      walletData = ["good service"]
      break;
      default:
      walletData = []
    }
    this.querySearch(walletData, navSelection);
  }

  assignImage(results){
    let domain = this.state.nav_selection
    let image_entity_dict = this.state.image_entity_dict
    for(var current = 0; current < results.length; current++){
      if(domain === "attractions" && exclusive_image_dict.special_attraction_pairs[results[current].entity_id]){
        results[current]["image"] = exclusive_image_dict.special_attraction_pairs[results[current].entity_id]
      } else if(image_entity_dict[results[current].entity_id]){
          results[current]["image"] = image_entity_dict[results[current].entity_id]
        } else {
          var dict_id = Object.keys(image_entity_dict).length
          var domain_images = image_dict[domain]
          var domain_img_count = image_dict[domain].length
          var ndx = (dict_id + this.state.seed) % domain_img_count
          results[current]["image"] = domain_images[ndx]
          image_entity_dict[results[current].entity_id] = domain_images[ndx]
        }
    }
    var set_to_state = {
      results: results,
      image_entity_dict: image_entity_dict
    }
    return set_to_state
  }

  updateState(data) {
    let results = data.results
    let set_to_state = this.assignImage(results)
    data["results"] = set_to_state.results
    data["image_entity_dict"] = set_to_state.image_entity_dict
    data["query_hovered"] = data.query_terms[data.query_terms.length-1];
    this.setState(data);
  }

  querySearch(args, navSelection) {
    if(navSelection === "whole_journey"){
      return
    }
    const result_type = navSelection ? navSelection : this.state.nav_selection;
    const request = {"result_type": result_type, "query_terms": args, "nearby_restaurants": 10}

    fetch(url, {
    headers: {
      Authorization: "Basic bmVvNGo6bWVnYWdvbg==",
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify(request),
    })
    .then((response) => response.json())
    .then((data) => {
      this.updateState(data);
    })
    .catch((error) => console.log(error))
  }


  eventLogToServer(ev, entity){
    const results = this.state.results
    const query_terms = this.state.query_terms
    const query_hovered = this.state.query_hovered

    //fill entity_dict
    var entity_dict = {}
    for(var i = 0; i < results.length; i++){
      if(results[i].entity_id === entity){
        entity_dict = results[i]
        break
      }
    }
      //define log data
    var log_data = { "event": ev, "entity_id": entity, "entity_dict": entity_dict, "query_terms": query_terms, "query_hovered": query_hovered }
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify(log_data),
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      cache: false,
      headers: {'Access-Control-Allow-Origin': 'http://localhost:3000'},
      success: (data) => {
        console.log("Data logged successfully. Event:", ev);
      },
      error: function(xhr, status, err) {
        console.log(status, err);
      }
    });
  }

  navSelection(selected){
    selected.preventDefault();
    var navItem = selected.target.getAttribute('name');
    this.defaultSearch(navItem)
    if(navItem !== this.state.nav_selection){
      this.setState({
        nav_selection: navItem,
        query_terms: [],
        results: [],
        see_more_clicked: [],
        query_hovered: ""
      })
    }
  }

  seeWholeJourney(selection){
    this.setState({nav_selection: selection})
    this.displayBody()
  }

  deleteQuery(term, ndx) {
    var oldTerms = this.state.query_terms;
    var navSelection= this.state.nav_selection;
    oldTerms.splice(ndx, 1);

    if(oldTerms.length === 0){
      this.setState({ query_terms: [],
      results: [], query_hovered: ""})
      return
    }
    if(this.state.query_hovered === term){
      this.setState({
        query_hovered: this.state.query_terms[0]
      })
    }
    this.querySearch(oldTerms, navSelection);
  }

  renderRevSummary(summary1){
    const each_desc = []
    const desc = summary1
    if(desc){
      const descCount = Math.min(desc.length, 3)
      for(var i = 0; i < descCount; i++){
        const txt = "\"" +  desc[i] + "\""
        const txt_trimmed = txt.trim()
        each_desc.push(<DescLi key={i} dangerouslySetInnerHTML={{__html: txt_trimmed}} ></DescLi>)
      }
    }
    return each_desc
  }

  updateHoverState(term, hover_active){
    this.setState( {
      query_hovered: term,
      hover_active: hover_active
    },
    () => {
      console.log("query hovered", this.state.query_hovered, "hover_active", this.state.hover_active)
    })
  }

  disableHover(){
    this.setState({ hover_active: false })
  }

  updateFavorites(entity_id, name, lat, lng, business_type, img_url, summary1){
    var selected_card = {entity_id: entity_id, name: name, latitude: lat, longitude: lng, business_type: business_type, img_url: img_url, desc: summary1 }

// apply necessary fav array based on selected card business type
    var array_of_favs;
    switch(business_type){
      case "hotel":
        array_of_favs = this.state.hotel_favs;
        break;
      case "attraction":
        array_of_favs = this.state.attraction_favs;
        break;
      case "restaurant":
        array_of_favs = this.state.restaurant_favs;
        break;
      default:
        array_of_favs= []
    }
    // var entity_id = selected_card.entity_id
    var handled_arr_of_favs = this.fav_array_handling(selected_card, entity_id, array_of_favs)
    this.setFavState(business_type, handled_arr_of_favs)
  }

  fav_array_handling(selected_card, entity_id, array_of_favs){
  // handle removing or adding favorite into array
      var removed = false
      for(var i = 0; i < array_of_favs.length; i++){
        if(array_of_favs[i].entity_id === entity_id){
          array_of_favs.splice(i, 1)
          removed = true
          this.eventLogToServer("removed_from_favorites", entity_id)
          break
        }
      }
      if(!removed){
          array_of_favs.push(selected_card)
          this.eventLogToServer("added_to_favorites", entity_id)
      }
      return array_of_favs
    }

  setFavState(biz_type, handled_arr_of_favs){
    switch(biz_type){
      case "hotel":
        this.setState({
          hotel_favs: handled_arr_of_favs
        },
        ()=> {console.log(this.state.hotel_favs)})
        break;
      case "attraction":
        this.setState({
          attration_favs: handled_arr_of_favs
        },
        ()=> {console.log(this.state.attraction_favs)})
        break;
      case "restaurant":
        this.setState({
          restaurant_favs: handled_arr_of_favs
        },
        ()=> {console.log(this.state.restaurant_favs )})
        break;
      default:
        console.log("no fav state set")
    }
  }

  displayBody(){
    if(this.state.nav_selection === "whole_journey"){
      return (
        <Content>
          <Journey hotel_favs={this.state.hotel_favs} attraction_favs={this.state.attraction_favs} restaurant_favs={this.state.restaurant_favs}
          renderRevSummary = {this.renderRevSummary}
          updateFavorites = {this.updateFavorites}
          eventLogToServer= {this.eventLogToServer}/>
        </Content>
      )
    }
    return (
    <Content>
      <SectionTitle data={this.state} />
      <SearchSection>
        <QueryBox data={this.state} onQuerySelect={this.deleteQuery} updateHoverState={this.updateHoverState}
        disableHover = {this.disableHover}
        apiCall={this.querySearch} />
      </SearchSection>
      <Results>
        <CardStyle>
          <SearchResults data={this.state} updateFavorites={this.updateFavorites} eventLogToServer={this.eventLogToServer} renderRevSummary={this.renderRevSummary} />
          <ImgDisclaimer> * Disclaimer: all pictures shown are not of the actual business or location.
          </ImgDisclaimer>
        </CardStyle>
        <MapPlacement>
          <MapStyle>
            <MapContainer data={this.state}/>
          </MapStyle>
          <LowerTitle>
            <Title>
            Voyageur
            </Title>
            <ProtoFlag>
              Demonstration Prototype
            </ProtoFlag>
          </LowerTitle>
        </MapPlacement>
      </Results>
    </Content>
    )
  }

  render() {
    const displayBody = this.displayBody()
    let props = {name: "Voyageur Demo", pub_ancor: "https://arxiv.org/pdf/1902.09661.pdf", blog_link: "https://megagon.ai/tag/opinedb/"}

    return (
      <Container>
        <AppWrapper props={props} >
        <NavigationBar>
          <Navigation onClick={this.navSelection}  data={this.state} />
        </NavigationBar>
        {displayBody}
        </AppWrapper>
      </Container>
    );
  }
}
